<tc-models-selection
  #modelsSelection
  class="content-stretch"
  [widgetInstanceKey]="widgetInstanceKey"
  (selectedElementChange)="onSelectedRow($event)"
></tc-models-selection>
